import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PackagesMobileComponent } from './packages-mobile.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    PackagesMobileComponent
  ],
  imports: [
    CommonModule,
    MatRadioModule,
    MatIconModule
  ],
  exports:[
    PackagesMobileComponent
  ]
})
export class PackagesMobileModule { }
